import { render, staticRenderFns } from "./OsItemPreventiva.vue?vue&type=template&id=49e670f8&"
import script from "./OsItemPreventiva.vue?vue&type=script&lang=js&"
export * from "./OsItemPreventiva.vue?vue&type=script&lang=js&"
import style0 from "./OsItemPreventiva.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports